import { render, staticRenderFns } from "./rewardThreeGiftEdit.vue?vue&type=template&id=2ceb24e6&scoped=true&"
import script from "./rewardThreeGiftEdit.vue?vue&type=script&lang=js&"
export * from "./rewardThreeGiftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb24e6",
  null
  
)

export default component.exports